import { useApi } from '@/api'

export const useReferencesResource = () => {
  const api = useApi()

  return {
    getReferences: (organizationId: string, deliverableId: string) =>
      api.api.v1.organizations({ organizationId }).deliverables({ deliverableId }).references.get(),
    getLooks: (organizationId: string, deliverableId: string, q = '') =>
      api.api.v1
        .organizations({ organizationId })
        .deliverables({ deliverableId })
        .looks.get({ query: q ? { q } : {} }),
    setReferenceUpload: (organizationId: string, deliverableId: string, file: File) =>
      api.api.v1.organizations({ organizationId }).deliverables({ deliverableId })['reference-uploads'].post({ file })
  }
}
